import React from 'react'
import Layout from '../../components/Default/Layout'
import PageHeader from '../../components/Default/PageHeader'
import '../../components/ParagraphUnderPhoto/styles.css'
import Accordion from '../../components/Accordion/Accordion'
import AccordionTemplate from '../../components/Services/AccordionTemplate'
import Content from '../../components/Services/content'
import { graphql } from 'gatsby'

const Index = props => {
  return (
    <Layout>
      <PageHeader
        title={'Služby'}
        backgroundImage={'https://conchmat.sirv.com/Images/sluzby.png'}
      />
      <div className="Paragraph--Wrapper container">
        <p>
          Nechte si poradit od skutečných profesionálů v oboru. Pomůžeme Vám
          zorientovat se v daňové a účetní legislativě a ulevíme od účetní či
          mzdové agendy. Všechna zadání řešíme odborně, efektivně a s Vaší
          minimální časovou investicí. Nabízíme konzultace jednotlivých
          transakcí i dlouhodobou spolupráci.
        </p>
        <p>
          K dispozici Vám budou certifikovaní daňoví poradci a kvalifikovaní
          účetní s praxí. Každý člen týmu má navíc svou specializaci, ve které
          se aktivně rozvíjí, díky čemuž víte, že se o Vás stará skutečný
          odborník.
        </p>
        <Accordion
          items={[
            {
              title: Content.dane.title,
              description: <AccordionTemplate {...Content.dane} />
            },
            {
              title: Content.mzdy.title,
              description: <AccordionTemplate {...Content.mzdy} />
            },
            {
              title: Content.zahranici.title,
              description: <AccordionTemplate {...Content.zahranici} />
            },
            {
              title: Content.firemniPoradenstvi.title,
              description: <AccordionTemplate {...Content.firemniPoradenstvi} />
            },
            {
              title: Content.ucetnictvi.title,
              description: <AccordionTemplate {...Content.ucetnictvi} />
            },
            {
              title: Content.znaleckePosudky.title,
              description: <AccordionTemplate {...Content.znaleckePosudky} />
            }
          ]}
        />
      </div>
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query Index {
    markdownRemark(frontmatter: { slug: { eq: "sluzby" } }) {
      frontmatter {
        meta {
          canonicalLink
          description
          noindex
          title
        }
        title
      }
    }
  }
`
